module.exports = __webpack_public_path__ + "asset/image-Property-1-Coffee-cup-1-959ef838af41833b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Property-1-Coffee-cup-1.svg
// module id = Zn4b
// module chunks = 0